import {notifyCatchedException, tryParseJSON} from "@/modules/utils";
import CustomMap, {type CoordinateDataset} from "@/modules/map";
import mapboxgl from "mapbox-gl";

interface LocationData {
    name: string;
    details: string;
    phone: string;
    flag: string;
    country: string;
    link: string
    iframe: string
    latitude: number
    longitude: number
}

let eventController: AbortController;

const initContactViewListeners = () => {
    const view = document.querySelector('[data-view="contact"]');
    if (!view) return;

    const mapNode = view.querySelector<HTMLElement>('#map__container');
    if (!mapNode) return;

    eventController?.abort();
    eventController = new AbortController();
    const {signal} = eventController;

    const picker = view.querySelector<HTMLElement>('#location__picker');

    const coordinates: CoordinateDataset[] = [];
    picker.querySelectorAll('[data-config]').forEach((el) => {
        const data = tryParseJSON(el.getAttribute('data-config'), {fallback: null}) as LocationData | null;
        if (!data) return;

        coordinates.push({
            popupContent: `<div>
                <span class="name">${data.name} - ${data.country}</span>
                <span class="desc">${data.details}</span>
                <span class="route"><hr/> <span>Voir l'itinéraire</span> <hr/></span>
            </div>`,
            gps: {
                latitude: data.latitude,
                longitude: data.longitude,
            }
        })
    })

    const mapInstance = CustomMap.init({
        container: mapNode,
        coordinates: coordinates,
        options: {
            interactive: true,
            zoom: 14,
            antialias: true,
            config: {
                basemap: {
                    showIndoor: true
                }
            }
        }
    })

    const __set = (key: string, value: any) => {
        mapInstance.setConfigProperty('basemap', key, value);
    }

    // Add geolocate control to the map.
    // mapInstance.addControl(
    //     new mapboxgl.GeolocateControl({
    //         positionOptions: {
    //             enableHighAccuracy: true
    //         },
    //         // When active the map will receive updates to the device's location as it changes.
    //         trackUserLocation: true,
    //         // Draw an arrow next to the location dot to indicate which direction the device is heading.
    //         showUserHeading: true
    //     })
    // );

    // Create and add the indoor floor selector to the map
    const indoorControl = new mapboxgl.IndoorControl();
    mapInstance.addControl(indoorControl);

    // Add navigation controls
    mapInstance.addControl(new mapboxgl.NavigationControl());

    mapInstance.on('style.load', () => {
        // mapNode.setAttribute('data-mode', isDay() ? 'light' : 'dark')
        // __set('lightPreset', isNight() ? 'night' : 'day');
        __set('showRoadLabels', true);
        __set('showPlaceLabels', true);
        __set('show3dObjects', true);
        __set('theme', 'default');
    });

    if (picker) {
        picker.querySelector('.handler').addEventListener('click', () => {
            picker.classList.toggle('render');
        }, {signal})

        const items = picker.querySelectorAll('[data-config]');
        items.forEach((el, i) => {
            el.addEventListener('click', () => {
                // const data = tryParseJSON(el.getAttribute('data-config'), {fallback: null}) as LocationData | null;

                const data = coordinates[i];

                if (!data) {
                    notifyCatchedException()
                    return;
                }

                mapInstance.panTo(
                    [data.gps.longitude, data.gps.latitude],
                    {duration: 500, animate: true}
                )

                picker.classList.remove('render');
                items.forEach(el => el.classList.remove('current'))
                el.classList.add('current');
            }, {signal});
        });
    }
}

export default initContactViewListeners;